import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { ACCOUNT_FEATURE, createListenerEffect, selectHasFeatureLoaded, waitFor } from '@socialive/common';
import {
  getAccountChannels,
  selectCurrentAccountId,
  setAccountChannels,
  setAccountInfo,
  setCurrentAccountId,
} from '~/store/accountInfo';
import { selectAuthToken } from '~/store/env';

export const effect = createListenerEffect(
  'accountInfo/fetchUserChannels<Listener>',
  async (action, { dispatch, getState, trigger, take }) => {
    await take((_, state) => selectHasFeatureLoaded(ACCOUNT_FEATURE.SPACES)(state));
    try {
      await waitFor({
        predicate: () => selectAuthToken(getState()) && selectCurrentAccountId(getState()),
        interval: 100,
        trigger,
      });
    } catch (error) {
      await dispatch(setAccountChannels({ channels: [], trigger }));
      return;
    }

    await dispatch(getAccountChannels({ trigger }));
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  matcher: isAnyOf(setCurrentAccountId, setAccountInfo),
  effect,
});

export default middleware;
